module.exports = __webpack_public_path__ + "img/zs-4.ad7db730.png";